import React, { useEffect } from "react";

// components

import Navbar from "components/Navbars/MarvyNavbar.js";
import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import moment from "moment";
import { darkTheme } from "lib/theme";
import { useAppState } from "lib/appState";
import { useRouter } from "next/router";

export default function MarvyLayout({
  children,
  noMenu,
  noHomeLink,
  authenticated = false,
  unauthenticated = false,
}) {
  const [appState, setAppState] = useAppState();
  const router = useRouter();

  useEffect(() => {
    if (authenticated && !appState.user) {
      router.push("/auth/login");
    }
    if (unauthenticated && appState.user) {
      router.push("/dashboard");
    }
  }, [authenticated, appState.user, router, unauthenticated]);
  return (
    <>
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <Box
          sx={{
            minHeight: "100vh",
            backgroundColor: "dark.main",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Navbar
            transparent
            noMenu={noMenu}
            noHomeLink={noHomeLink}
            authenticated={authenticated}
            unauthenticated={unauthenticated}
          />
          <Box
            sx={{
              flex: 1,
              color: "white.main",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "stretch",
              width: {
                xs: "100%",
                sm: 600,
              },
            }}
            component="main"
          >
            {children}
          </Box>
          <Box
            component="footer"
            sx={{
              fontSize: 24,
              fontWeight: "bold",
              color: "rgba(255, 255, 255, 0.2)",
              paddingY: "20px",
            }}
          >
            © Uptimeline {moment().format("YYYY")}
          </Box>
        </Box>
      </ThemeProvider>
      <CssBaseline />
    </>
  );
}
